var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsgbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2662 4.00517L11.5751 9.00765L2.8872 4.01013L2.88782 2.01012L11.5758 7.00765L20.2668 2.00517M20.2674 0.00516406L2.88844 0.0101224C1.68277 0.0104664 0.715789 0.900743 0.715445 2.01074L0.711726 14.0108C0.711561 14.5412 0.940278 15.0498 1.34756 15.4248C1.75484 15.7997 2.30733 16.0103 2.88348 16.0101L20.2624 16.0052C20.8386 16.005 21.3912 15.7941 21.7987 15.419C22.2062 15.0438 22.4353 14.535 22.4354 14.0046L22.4392 2.00455C22.4395 0.894545 21.4622 0.00482318 20.2674 0.00516406Z",
    fill: "url(#paint0_linear_119_258)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_119_258",
    x1: 11.5779,
    y1: 0.00764279,
    x2: 17.5438,
    y2: 5.93667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7FF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE1F7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgbox);
export default __webpack_public_path__ + "static/media/msgbox.85ab6c0ab41667deeb4c16f2940b23ed.svg";
export { ForwardRef as ReactComponent };